import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Guard for authenticated pages (e.g. Dashboard)
export const ProtectedRoute = ({ requiredRole = null, children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access if requiredRole is specified
  if (requiredRole) {
    const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!allowedRoles.includes(user.role)) {
      // Redirect to appropriate dashboard based on user's actual role
      const dashboardPath = getDashboardPath(user.role);
      return <Navigate to={dashboardPath} replace />;
    }
  }

  return children ? children : <Outlet />;
};

// Helper function to get dashboard path based on role
const getDashboardPath = (role) => {
  switch (role) {
    case 'ADMIN':
      return '/admin/dashboard';
    case 'EDUCATOR':
      return '/dashboard/educator';
    case 'PROFESSIONAL':
      return '/dashboard/professional';
    case 'STUDENT':
      return '/dashboard/student';
    default:
      return '/dashboard';
  }
};

// Guard for guest-only pages (e.g. Login, Signup)
export const GuestRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (user) {
    // Redirect based on user role
    const redirectPath = user.role === 'ADMIN' ? '/admin/dashboard' : '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};
